import { render, staticRenderFns } from "./AssignmentCreateModal.vue?vue&type=template&id=5f4cea76&scoped=true"
import script from "./AssignmentCreateModal.vue?vue&type=script&lang=js"
export * from "./AssignmentCreateModal.vue?vue&type=script&lang=js"
import style0 from "./AssignmentCreateModal.vue?vue&type=style&index=0&id=5f4cea76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cea76",
  null
  
)

export default component.exports